import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="error-page-bg">
      <div className="container">
        <div className="row">
          {/* Left Content */}
          <div className="col-lg-7 d-flex align-items-center">
            <div className="error-content">
              <h1>
                404 <span>Error</span>
              </h1>
              <p>
                Uh-oh! We couldn’t find that page! Looks like you’ve hit a broken link or mistyped something. Don’t worry — we’re here to help you find your way.
              </p>
              <Link className="primary-btn3" to="/">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6.54084 0.0619907C6.45311 0.0976515 6.33521 0.160745 6.28038 0.199148C6.22281 0.237553 4.83826 1.61188 3.19873 3.25229C0.797022 5.66079 0.207561 6.26428 0.149986 6.37949C-0.113215 6.91167 -0.0254814 7.49322 0.377545 7.89921C0.62978 8.14883 0.950556 8.28051 1.31794 8.28051H1.50438V10.475C1.50438 11.9591 1.51534 12.7135 1.53453 12.8122C1.63872 13.3115 2.04174 13.7641 2.54073 13.9369C2.72168 14 2.73539 14 4.05962 14C5.36466 14 5.39482 14 5.46884 13.9424C5.50997 13.9122 5.57029 13.8519 5.60044 13.8107C5.65802 13.7367 5.65802 13.701 5.67173 11.9042L5.68544 10.0718L5.76769 9.93738C5.87187 9.77004 6.08298 9.63563 6.28586 9.61094C6.36263 9.59997 6.74647 9.59722 7.13853 9.60271L7.85136 9.61094L7.99667 9.69049C8.13376 9.7673 8.22149 9.85782 8.30648 10.0087C8.33664 10.0663 8.34761 10.4037 8.35857 11.907C8.37228 13.701 8.37228 13.7367 8.42986 13.8107C8.46002 13.8519 8.52033 13.9122 8.56146 13.9424C8.63548 14 8.66564 14 9.97068 14C11.2949 14 11.3086 14 11.4896 13.9369C11.9886 13.7641 12.3916 13.3115 12.4958 12.8122C12.515 12.7135 12.5259 11.9591 12.5259 10.475V8.28051H12.7124C13.2278 8.28051 13.6774 8.00619 13.8995 7.55357C13.9927 7.36429 13.9927 7.3588 13.9927 6.99122C13.9927 6.36578 14.308 6.73611 10.7877 3.21663C7.28932 -0.286391 7.64025 0.015357 7.04257 0.00164127C6.73276 -0.00384521 6.68615 0.00164127 6.54084 0.0619907ZM7.21803 0.846535C7.37979 0.923344 13.1099 6.66478 13.1702 6.80468C13.2278 6.94459 13.2223 7.06254 13.1538 7.1997C13.0523 7.41092 12.9673 7.4411 12.4382 7.45756C11.9419 7.47127 11.9063 7.48225 11.7747 7.66055C11.7171 7.73462 11.7171 7.76479 11.7034 10.2227L11.6897 12.7107L11.6129 12.8396C11.5718 12.911 11.4978 13.0015 11.4484 13.0371C11.2565 13.1853 11.199 13.1908 10.1516 13.1908H9.18108V11.6546C9.18108 10.6479 9.17011 10.0718 9.15092 9.97578C9.04399 9.46007 8.63 9.01567 8.09811 8.84834C7.91716 8.79073 7.85685 8.78799 7.01515 8.78799C6.03363 8.78799 5.98428 8.79348 5.63334 8.97178C5.28515 9.14735 4.96163 9.58076 4.87938 9.97578C4.86019 10.0718 4.84922 10.6479 4.84922 11.6546V13.1908H3.87867C2.83135 13.1908 2.77377 13.1853 2.58186 13.0371C2.53251 13.0015 2.45848 12.911 2.41735 12.8396L2.34059 12.7107L2.32688 10.2227C2.31317 7.76479 2.31317 7.73462 2.2556 7.66055C2.124 7.48225 2.08835 7.47127 1.59211 7.45756C1.06297 7.4411 0.977973 7.41092 0.876531 7.1997C0.807989 7.06254 0.802506 6.94459 0.860081 6.80468C0.917656 6.66753 6.65051 0.926086 6.80952 0.846535C6.94935 0.777956 7.07821 0.777956 7.21803 0.846535Z" />
                </svg>
                Back To Home
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-5">
            <div className="error-img">
              <img
                className="img-fluid"
                src="/assets/img/banners/404.png"
                alt="Error"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
